<!-- home 首页 -->
<template>
  <div class="homepage">
    <v-head></v-head>
    <div class="container">
      <!-- banner轮播 -->
      <div class="homepage-banner">
        <div class="banner-img"></div>
        <div class="homepage-banner-con">
          <div class="homepage-banner-title">平台简介</div>
          <div class="homepage-banner-message">到梦空间是一款大学生第二课堂综合育人的APP，它的主要功能是校内外各类组织发布、管理活动，学生直接参加活动，到梦空间实现大学校园活动的发布、在线报名、打卡签到、颁奖、颁发学分、评价等功能，最后生成一张的第二课堂成绩单。产品归北京科技大学所有，向在校大学生提供服务。</div>
          <div class="homepage-banner-message">在大学生综合素质评价的大背景下，不仅实现了工具的服务，也大量引入优质课程进入第二课堂。通过第二课堂产教融合的方式，吸引行业组织、龙头企业参与第二课堂，方便同学们高效率、便捷地参加高质量的活动。</div>
        </div>
      </div>
      <!-- 企业展示 -->
      <div class="homepage-businesses">
        <div class="businesses-title">共建活动参考</div>
        <div class="businesses-contents">
          <div class="item" style="margin-right: 35px;">
            <img src="../../assets/img/activity-1.png" alt="">
            <div class="text">为全面推动新时代大学生传承红色基因、激发爱国热情，深入了解大庆精神（铁人精神）的内涵与价值，以青春担当为实现中华民族伟大复兴贡献力量，各高校共同组织开展“铁人精神 时代传承”2024年全国大学生大庆精神弘扬行动之知识科普讲座。</div>
          </div>
          <div class="item">
            <img src="../../assets/img/activity-2.png" alt="">
            <div class="text">为加强沿黄九省区高校青年学子交流互动，组织引导广大团员青年在黄河流域开展生态保护、净滩护水等志愿服务活动，用青春行动为大地添绿增彩，以青春有为“让黄河成为造福人民的幸福河”，各高校团委等单位共同组织开展2024年全国大学生“对话母亲河”黄河流域生态保护知识竞赛。</div>
          </div>
          <div class="item" style="margin-left: 35px;">
            <img src="../../assets/img/activity-3.png" alt="">
            <div class="text">为组织引导广大青年学子弘扬光荣传统、赓续红色血脉，深刻领会和准确把握沂蒙精神的丰富内涵，努力将其转化为青春为中国式现代化挺膺担当的强大动力和生动实践；各高校团委等单位共同组织开展“红色沂蒙，青春力量”全国大学生弘扬沂蒙精神作品征集活动。</div>
          </div>
        </div>
      </div>
    </div>
    <!-- footer -->
    <v-footer></v-footer>
  </div>
</template>

<script>
// eslint-disable-next-line
import vHead from '@/components/header/header.vue'
import vFooter from '@/components/footer/footer.vue'
export default {
  components: {
    'v-head': vHead,
    'v-footer': vFooter
  },
  created () {
    // 移动端适配最小高度为浏览器高度
    this.$nextTick(() => {
      let containerDom = document.getElementsByClassName('container')[0]
      if (containerDom) {
        containerDom.style.minHeight = (document.documentElement.clientHeight - 100) + 'px'
      }
    })
  },
  methods: {
    // 判断当前dom元素是否在页面可视区域展示
    getElementTopLeft (obj) {
      var top = 0
      var left = 0
      while (obj) {
        top += obj.offsetTop
        left += obj.offsetLeft
        obj = obj.offsetParent
      }
      return { top: top, left: left }
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style src='./homepage.scss' lang='scss' scoped></style>
<style src='./homepage_native.scss' lang='scss'></style>



// WEBPACK FOOTER //
// src/views/homepage/home.vue